'use client';

import { FC, ReactNode, useEffect } from 'react';
import { ArrowLeft, X } from 'lucide-react';
import styles from './AuthShell.module.scss';
interface AuthShellProps {
  show: boolean;
  onClose: () => void;
  onBack?: () => void;
  children: ReactNode;
}
const AuthShell: FC<AuthShellProps> = ({
  show,
  onClose,
  onBack,
  children
}) => {
  useEffect(() => {
    if (!show) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [show, onClose]);
  if (!show) return null;
  return <div className={styles.backdrop} onClick={e => {
    if (e.target === e.currentTarget) onClose();
  }} data-sentry-component="AuthShell" data-sentry-source-file="AuthShell.tsx">
            <div className={styles.card} role="dialog" aria-modal="true">
                {onBack && <button type="button" className={`${styles.iconBtn} ${styles.backBtn}`} onClick={onBack} aria-label="Back">
                        <ArrowLeft size={20} strokeWidth={2} />
                    </button>}
                <button type="button" className={`${styles.iconBtn} ${styles.closeBtn}`} onClick={onClose} aria-label="Close">
                    <X size={20} strokeWidth={2} data-sentry-element="X" data-sentry-source-file="AuthShell.tsx" />
                </button>
                <div className={styles.body}>{children}</div>
            </div>
        </div>;
};
export default AuthShell;